import { analyzeImageQuality } from './backbone/features/mobileForm/imageField/imageQualityChecker';

window.analyzeImageQualityFunc = analyzeImageQuality;
